import { render, staticRenderFns } from "./ComTemplateFormat.vue?vue&type=template&id=ec871b44&scoped=true&"
import script from "./ComTemplateFormat.vue?vue&type=script&lang=js&"
export * from "./ComTemplateFormat.vue?vue&type=script&lang=js&"
import style0 from "./ComTemplateFormat.vue?vue&type=style&index=0&id=ec871b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec871b44",
  null
  
)

export default component.exports